import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const fileUrl = (path) => `${API}/files/${path}`;

export const api = axios.create({ baseURL: API, withCredentials: true });
api.interceptors.request.use((cfg) => {
  const tok = localStorage.getItem("rr_token");
  if (tok) cfg.headers.Authorization = `Bearer ${tok}`;
  return cfg;
});

export function errDetail(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "error";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

export const TZ = "America/Toronto";

export function mtlToday(offsetDays = 0) {
  const d = new Date(Date.now() + offsetDays * 86400000);
  return new Intl.DateTimeFormat("en-CA", { timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit" }).format(d);
}

export function fmtDate(dateStr, lang) {
  const [y, m, d] = dateStr.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d, 12)).toLocaleDateString(lang === "fr" ? "fr-CA" : "en-CA", {
    weekday: "short", day: "numeric", month: "short", timeZone: "UTC",
  });
}

export function fmtDateTime(isoStr, lang) {
  if (!isoStr) return "—";
  return new Date(isoStr).toLocaleString(lang === "fr" ? "fr-CA" : "en-CA", {
    timeZone: TZ, dateStyle: "medium", timeStyle: "short",
  });
}

export function money(v, lang) {
  return new Intl.NumberFormat(lang === "fr" ? "fr-CA" : "en-CA", { style: "currency", currency: "CAD" }).format(v || 0);
}

export const mapsEmbed = (q) => `https://www.google.com/maps?q=${encodeURIComponent(q)}&output=embed`;
